import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService, DocumentService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as vaultSelector from '../../../../../root-store/vault-store/vault.selector';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-transaction-attribute',
  templateUrl: './add-transaction-attribute.component.html',
  styleUrls: ['./add-transaction-attribute.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTransactionAttributeComponent implements OnInit, OnDestroy {
  @Input() mode;
  @Input() name;
  @Input() data;
  @Input() currentuserId;
  @Input() currentFormId;
  @Input() userId;
  @Input() isRemoveEditSaveSharing;
  @Input() fId;
  @Input() connected_to_institution;
  @Input() currentValutUserId;
  @Input() transaction_register_disabled;
  screenWidth;
  has_transaction = false;
  currentValue;
  isLoading = true;
  totalCount;
  currentDate;
  transactionData = {};
  showNothingtoSHow = false;
  showReviewCOunt = false;
  showCompleteCount = false;
  showTransactionInfo;
  reviewedCount = 0;
  subscription = new Subscription();
  constructor(
    private documentService: DocumentService,
    private commonService: CommonService,
    private store: Store,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.screenWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.showTransactionInfo = this.transaction_register_disabled == 0 ? false : true;
    this.screenWidth = window.innerWidth;
    this.getList();

    this.subscription.add(
      this.commonService.updateTransactionCountData.subscribe((data) => {
        this.getCount();
      })
    );
  }

  getUpdateList(id, fId) {
    this.currentFormId = id;
    this.fId = fId;
    this.getList();
  }

  getList() {
    if (this.currentFormId) {
      this.subscription.add(
        this.store.select(vaultSelector.getCurrentFormsById(this.fId)).subscribe((response) => {
          this.isLoading = false;
          this.has_transaction = response?.financial_attributes.indexOf('has_transaction') == -1 ? false : true;
          if (this.has_transaction && this.showTransactionInfo) this.getCount();
          this.cd.markForCheck();
        })
      );
    } else {
      this.isLoading = false;
    }
  }

  updateVaultUserFormTransactionRegisterStatus() {
    const payload = {
      id: this.currentFormId,
      transaction_register_disabled: this.showTransactionInfo,
    };
    this.subscription.add(
      this.documentService.updateVaultUserFormTransactionRegisterStatus(payload).subscribe(
        (res) => {
          if (this.has_transaction && this.showTransactionInfo) this.getCount();
          this.cd.detectChanges();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  getCount() {
    if (this.currentFormId) {
      let needToPassCurrntUserId = this.userId ?? this.currentValutUserId ?? this.currentuserId;
      if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
        needToPassCurrntUserId = this.currentuserId;
      }
      this.subscription.add(
        this.documentService.getTransactionStatus(needToPassCurrntUserId, this.currentFormId).subscribe((res) => {
          this.totalCount = +res?.data?.total;
          if (+res?.data?.total - +res?.data?.total_reviewed > 0) {
            this.reviewedCount = +res?.data?.total - +res?.data?.total_reviewed;
            this.showReviewCOunt = true;
            this.showCompleteCount = false;
          } else {
            this.showCompleteCount = true;
            this.showReviewCOunt = false;
          }

          this.cd.detectChanges();
        })
      );
    }
  }

  handleTransactionRegisterDrawerEvent() {
    this.transactionData = {
      currentFormId: this.currentFormId,
      registerType: 'transaction',
      name: this.name,
      currentuserId: this.currentuserId,
      currentValutUserId: this.currentValutUserId,
      connected_to_institution: this.connected_to_institution,
      isEdit: !this.isRemoveEditSaveSharing && this.mode != 'view' ? true : false,
    };
    this.commonService.toggleTransactionRegisterSidenav({ data: this.transactionData, open: true });
    this.cd.detectChanges();
  }

  toggleTransactionView(event) {
    event.preventDefault();
    this.showTransactionInfo = !this.showTransactionInfo;
    this.updateVaultUserFormTransactionRegisterStatus();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
